var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C14.411 2 18 5.589 18 10C18 11.3 17.681 12.591 17.077 13.733C16.948 13.978 16.645 14.071 16.401 13.942C16.157 13.813 16.063 13.511 16.193 13.267C16.721 12.267 17 11.138 17 10C17 6.141 13.86 3 10 3C6.14 3 3 6.141 3 10C3 13.859 6.14 17 10 17C11.139 17 12.268 16.721 13.266 16.192C13.512 16.064 13.813 16.157 13.942 16.401C14.071 16.646 13.978 16.947 13.734 17.077C12.592 17.681 11.301 18 10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2ZM10 7.9502C10.304 7.9502 10.55 8.1962 10.55 8.5002V14.4902C10.55 14.7942 10.304 15.0402 10 15.0402C9.696 15.0402 9.45 14.7942 9.45 14.4902V8.5002C9.45 8.1962 9.696 7.9502 10 7.9502ZM10 4.875C10.345 4.875 10.625 5.154 10.625 5.5C10.625 5.845 10.345 6.125 10 6.125C9.655 6.125 9.375 5.845 9.375 5.5C9.375 5.154 9.655 4.875 10 4.875Z",
    fill: "#0072CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8c94c624.svg";
export { ForwardRef as ReactComponent };